export default __webpack_public_path__ + "static/media/icon_skill_shield_red.b1aa7beb.png";